import {
  AlertType,
  CreateAlertInput,
  CreateAlertMutationVariables,
  ListAlertsByUserQueryVariables,
  ListPopUpsByStatusQueryVariables,
  ModelSortDirection,
  PopUpStatus,
} from "../API";
import API from "@aws-amplify/api";
import { buildVariables } from "../libs/GraphQueryBuilder";
import { mutation, query } from "gql-query-builder";
import { UserAttributes, searchUsers } from "./UsersManager";

// id?: string | null,
//     title?: string | null,
//     detail?: string | null,
//     pollID?: string | null,
//     message?: string | null,
//     type: AlertType,
//     createdAt?: string | null,
//     userID: string,
export async function createTargetAlerts(
  type: AlertType,
  userAttributes: UserAttributes,
  pollID,
  message: string
) {
  const users: any = await searchUsers(userAttributes);
  let user: any;
  for (user of users) {
    console.log(`user ${JSON.stringify(user)}`);
    const res = await createAlert({
      pollID,
      message,
      type,
      userID: user.id,
    });
    console.log(`res ${JSON.stringify(res)}`);
  }
}

export function listPopUps(limit = 10, nextToken: string | null = null) {
  const _variables: ListPopUpsByStatusQueryVariables = {
    status: PopUpStatus.CREATED,
    limit,
    sortDirection: ModelSortDirection.DESC,
  };
  if (nextToken != null) {
    _variables.nextToken = nextToken;
  }
  const variables = buildVariables<ListPopUpsByStatusQueryVariables>(
    _variables,
    [
      { key: "status", name: "PopUpStatus" },
      { key: "sortDirection", name: "ModelSortDirection" },
    ]
  );
  const q = query({
    operation: "result: listPopUpsByStatus",
    fields: [
      {
        items: [
          "type",
          {
            poll: [
              "owner",
              "title",
              {
                image: ["key", "bucket", "region"],
              },
            ],
          },
          "pollID",
          "updatedAt",
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export function createAlert(input: CreateAlertInput) {
  const ops = createAlertOperation(input);
  return API.graphql(ops);
}

function createAlertOperation(input: CreateAlertInput) {
  const _variables: CreateAlertMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateAlertMutationVariables>(_variables, [
    { key: "input", name: "CreateAlertInput!" },
  ]);

  return mutation({
    operation: "result: createAlert",
    fields: ["id"],
    variables,
  });
}

export function listAlertsByUser(userID: string, limit: number, nextToken) {
  const ops = listAlertsByUserOperation(userID, limit, nextToken);
  return API.graphql(ops);
}

function listAlertsByUserOperation(userID: string, limit: number, nextToken) {
  const fields = [
    {
      items: [
        "id",
        "title",
        "type",
        "detail",
        "pollID",
        "userID",
        "owner",
        "createdAt",
        "message",
      ],
    },
    "nextToken",
  ];
  const _variables: ListAlertsByUserQueryVariables = {
    userID,
    sortDirection: ModelSortDirection.DESC,
    limit,
  };
  if (nextToken != null) {
    _variables.nextToken = nextToken;
  }

  const variables = buildVariables<ListAlertsByUserQueryVariables>(_variables, [
    { key: "userID", name: "ID!" },
    { key: "sortDirection", name: "ModelSortDirection" },
  ]);
  console.log(`listAlertsByUser variables ${JSON.stringify(variables)}`);

  return query({
    operation: "result: listAlertsByUser",
    fields,
    variables,
  });
}
